import request from '@/libs/request';

/**
 * 获取所有区域信息
 */
export const getCountryListApi = () => {
  return request({
    url: '/trademark/base/area/list',
    method: 'get',
  });
};

/**
 * 缓存中获取国家数据
 */
export const getCacheCountryListApi = () => {
  return request({
    url: '/order/management/country/countryList',
    method: 'post',
  });
};

/**
 * 获取有商标注册单的国家
 */
export const getCountryListHaveOrder = () => {
  return request({
    url: '/workorder/client/trademark/workorder/getWorkOrderCountrylist',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

export const getInfoDetailCacheCountry = (url) => {
  return request({
    url,
    method: 'post',
  });
};



// WEBPACK FOOTER //
// ./src/api/country.js